import React from 'react'
import { createBrowserRouter } from 'react-router-dom'
import Root from './components/RootPage'

// import Home from './routes/Home'
import NotFound from './routes/NotFound'
import Login from './routes/Login/LoginPage'
import Home from './Home/MainPage'

// Router 배열을 만들어서 export
const router = createBrowserRouter([
  {
    // root : 모든 앱의 모든 화면의 최상위 컴포넌트 (/rooms, /users 등)
    // 즉, header, footer, sidebar 등의 공통 컴포넌트를 여기에 넣어준다.
    path: '/',
    element: <Root />,
    // 404 페이지를 여기에 넣어준다.
    errorElement: <NotFound />,
    children: [
      { path: '/', element: <Home /> },
      // { path: '/login', element: <Login /> },
      // { path: '/companyAdd', element: <CompanyCreate /> },
      // { path: '/companyView', element: <CompanyView /> },
      // {
      //   path: 'register',
      //   children: [
      //     {
      //       path: 'type',
      //       element: <IsCompany />,
      //     },
      //     {
      //       path: 'company',
      //       element: <CompanyRegister />,
      //     },
      //     {
      //       path: 'employee',
      //       element: <EmployeeRegister />,
      //     },
      //   ],
      // },
    ],
  },
])

// 🚨 export 까먹지 말기
export default router
